/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilebillingstreet2Inputs */

const en_profilebillingstreet2 = /** @type {(inputs: Profilebillingstreet2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Street and number`)
};

const de_profilebillingstreet2 = /** @type {(inputs: Profilebillingstreet2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Straße und Hausnummer`)
};

/**
* | output |
* | --- |
* | "Street and number" |
*
* @param {Profilebillingstreet2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilebillingstreet2 = /** @type {((inputs?: Profilebillingstreet2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilebillingstreet2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilebillingstreet2(inputs)
	return de_profilebillingstreet2(inputs)
});
export { profilebillingstreet2 as "profileBillingStreet" }